import React from 'react'
import {Badge} from 'reactstrap';
export default function Tag(props) {
  return (
    <li className="list-inline-item" onClick={()=> props.handleTag()} style={{margin:"3px 5px 3px 5px"}}>
      <Badge color="dark"  style={{cursor:"pointer"}}>{props.tag.name}</Badge>
    </li>
  )
}
